import React, { useMemo, useState } from 'react'

import { TableColumns } from '@base'
import { strings } from '@constants'
import { displayAmount } from '@utils'
import Switch from '../Switch'
import { HeaderWapper, Heading, TableContainer, TableWapper, Wapper } from '../style'
import { paths } from '@routes'

const TYPE = {
	ENQUIRY: 'ENQUIRY',
	INVOICES: 'INVOICES',
	PAYMENT: 'PAYMENT',
}
const RecentUpdates = ({ enquiries, payments, invoices }) => {
	const [status, setStatus] = useState(TYPE.ENQUIRY)
	const columns = useMemo(() => {
		if (status === TYPE.ENQUIRY)
			return [
				TableColumns.idColumn({}),
				TableColumns.dateColumn({ label: strings('date'), align: 'start', key: 'date' }),
				{
					label: strings('buyer'),
					key: 'buyer_name',
					mobile: true,
				},
				{
					label: strings(['buyer', 'quote', 'sent']),
					key: 'buyer_quote_sent',
					mobile: false,
				},
				{
					label: strings('category'),
					key: 'category',
					mobile: false,
				},
				{
					label: strings(['no', 'of', 'quotes']),
					key: 'no_of_quotes',
					mobile: true,
				},
				{
					label: strings('quantity'),
					key: (item) => {
						return item?.quantity ? `${item?.quantity} ${strings('mt')} ` : '-'
					},
					mobile: false,
				},
				{
					label: strings('status'),
					key: 'status',
					mobile: false,
				},
			]
		if (status === TYPE.INVOICES)
			return [
				TableColumns.dateColumn({ label: strings('date'), align: 'start', key: 'date' }),
				TableColumns.dateColumn({ label: strings('due', 'date'), align: 'start', key: 'due_date' }),
				{
					label: strings('buyer'),
					key: 'buyer_name',
					mobile: true,
				},
				// {
				// 	label: strings('input', 'type'),
				// 	key: 'input_type',
				// 	mobile: true,
				// },
				{
					label: strings('invoice', 'number'),
					key: 'invoice_number',
					mobile: true,
				},
				{
					label: strings('amount'),
					key: (item) => {
						return item?.amount ? `${displayAmount(item?.amount)}` : '-'
					},
					mobile: true,
				},
				{
					label: strings('quantity'),
					key: (item) => (item?.quantity ? `${item?.quantity} ${strings('mt')} ` : '-'),
					mobile: true,
				},
				{
					label: strings('po', 'number'),
					key: (item) => (item?.po_number ? item?.po_number : '-'),
					mobile: true,
				},
			]
		if (status === TYPE.PAYMENT)
			return [
				TableColumns.dateColumn({ label: strings('date'), align: 'start', key: 'date' }),
				{
					label: strings('buyer'),
					key: 'buyer_name',
					mobile: true,
					align: 'start',
				},
				{
					label: strings('amount'),
					key: (item) => {
						return item?.amount ? `${displayAmount(item?.amount)}` : '-'
					},
					mobile: true,
				},
				{
					label: strings('document', 'number'),
					key: 'document_number',
					mobile: true,
				},
			]
	}, [status])

	const _data = status === TYPE.ENQUIRY ? enquiries : status === TYPE.INVOICES ? invoices : payments

	const rowClickHandler = (row) => {
		let _path
		if (status === TYPE.ENQUIRY) {
			_path = paths.admin_manage_enquiry_manage(row?.enquiry_id)
		} else if (status === TYPE.INVOICES) {
			_path = paths.admin_manage_enquiry_order_edit(row?.order_id)
		} else if (status === TYPE.PAYMENT) {
			_path = `${paths.admin_ledger}?transaction_source=DEPOSIT&organisation=${row?.org_id}`
		}
		window.open(_path, '_blank')
	}

	return (
		<Wapper FlexColumn>
			<HeaderWapper>
				<Heading>Recent Updates</Heading>
				<Switch
					options={[
						{ label: strings('enquiry'), value: TYPE.ENQUIRY },
						{ label: strings('invoices'), value: TYPE.INVOICES },
						{ label: strings('payment'), value: TYPE.PAYMENT },
					]}
					value={status}
					onChange={setStatus}
				/>
			</HeaderWapper>
			<TableContainer>
				<TableWapper
					fullHeight={true}
					data={_data || []}
					columns={columns}
					rowsToDisplay={10}
					totalItemCount={50}
					page={0}
					onRowClick={rowClickHandler}
					rowClickable={true}
					hideFooter
				/>
			</TableContainer>
		</Wapper>
	)
}

export default RecentUpdates
